// src/utils/scrollManager.js

/**
 * Gestor centralizado de scroll para modales.
 * Previene el salto al top cuando se abre un modal.
 */

let scrollPosition = 0;
let isLocked = false;

export const scrollManager = {
  /**
   * Bloquea el scroll y guarda la posición actual.
   * Debe llamarse ANTES de abrir el modal.
   */
  lock() {
    if (isLocked) return;

    // Guardar posición actual
    scrollPosition = window.scrollY;

    // Obtener ancho del scrollbar
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    // Aplicar estilos para bloquear scroll
    const body = document.body;
    body.style.position = 'fixed';
    body.style.top = `-${scrollPosition}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    
    // Compensar scrollbar
    if (scrollbarWidth > 0) {
      body.style.paddingRight = `${scrollbarWidth}px`;
    }

    isLocked = true;
    console.log('🔒 Scroll bloqueado en:', scrollPosition);
  },

  /**
   * Desbloquea el scroll y restaura la posición guardada.
   * Debe llamarse DESPUÉS de cerrar el modal.
   */
  unlock() {
    if (!isLocked) return;

    const body = document.body;
    const savedPosition = scrollPosition;

    // Remover estilos
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    body.style.overflow = '';
    body.style.paddingRight = '';

    // Restaurar scroll
    window.scrollTo(0, savedPosition);

    isLocked = false;
    console.log('🔓 Scroll restaurado a:', savedPosition);
  },

  /**
   * Verifica si el scroll está bloqueado
   */
  isLocked() {
    return isLocked;
  },

  /**
   * Obtiene la posición guardada
   */
  getPosition() {
    return scrollPosition;
  }
};